import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/store.enums";
import {ReviewsActions, ReviewsMutation} from "@/modules/reviews/store/enums";
import store from "@/store";

@Module
export default class Store extends VuexModule {
    renderKey = 1;
    listParams = {
        page: 1,
        results: 10,
        search: null,
        sort: [],
        filter: {}
    };
    listCache = [];
    listTotal = 0;

    get getReviewsRenderKey() {
        return 'reviews-' + this.renderKey;
    }

    get getReviewsLastListResult() {
        return this.listCache;
    }

    get getReviewsLastListTotal() {
        return this.listTotal;
    }

    get getReviewsMappingFields() {
        return {
            reviewer: {
                required: true,
                label: 'reviews.reviewer',
                mapping: null,
                unique: false,
                duplicates: null,
                options: null,
                optionsMulti: false,
                optionsMapped: {}
            },
            rating: {
                required: false,
                label: 'reviews.rating',
                mapping: null,
                unique: false,
                duplicates: null,
                options: null,
                optionsMulti: false,
                optionsMapped: {}
            },
            message: {
                required: false,
                label: 'reviews.message',
                mapping: null,
                unique: false,
                duplicates: null,
                options: null,
                optionsMulti: false,
                optionsMapped: {}
            },
            date: {
                required: false,
                label: 'reviews.date',
                mapping: null,
                unique: false,
                duplicates: null,
                options: null,
                optionsMulti: false,
                optionsMapped: {}
            }
        };
    }

    @Mutation
    [ReviewsMutation.SET_RENDER_UPDATE]() {
        this.renderKey++;
    }

    @Mutation
    [ReviewsMutation.SET_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.listParams = listParams;
        this.listCache = listCache;
        this.listTotal = listTotal;
    }

    @Action
    [ReviewsActions.REFRESH_LIST]() {
        this.context.dispatch(ReviewsActions.FETCH_LIST, this.listParams);
    }

    @Action
    [ReviewsActions.FETCH_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("reviews/list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ReviewsMutation.SET_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ReviewsActions.GET_ITEM](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`reviews/get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ReviewsActions.CREATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            const {data} = payload;

            apiService.post('reviews/create/', data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ReviewsMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ReviewsActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ReviewsActions.UPDATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data} = payload;

            apiService.put(`reviews/edit/${editId}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ReviewsActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ReviewsActions.DELETE_ITEM](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`reviews/delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ReviewsActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ReviewsActions.UPDATE_TRANSLATION](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('reviews/update-translation', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ReviewsActions.IMPORT_REVIEWS](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('reviews/import-reviews', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ReviewsMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ReviewsActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ReviewsActions.ADD_IMAGE](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('reviews/add-image', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ReviewsActions.DELETE_IMAGE](imageId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`reviews/delete-image/${imageId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

}
